import axios from 'axios';
import { errorInteractions } from '../../analytics';
import logNewRelicCustom from '../../utils/logNewRelicCustom';
import { NEW_RELIC_EVENTS } from '../../constants';

// eslint-disable-next-line consistent-return
export const getPrice = async (host, designData) => {
  const errorMsg = 'Get Price: Request failed';
  try {
    const response = await axios.post(
      `${host}/api/modulardesigner/priceadjustment`,
      designData,
    );
    if (response?.status === 200) {
      return response;
    }
  } catch (err) {
    const errorObject = {
      type: 'catastrophic',
      displayType: 'inline',
      pageSection: 'Get Price',
      message: errorMsg,
    };
    const trackErrorInteractions = { errorObject, primaryCategory: 'error', eventName: 'post page error' };
    errorInteractions(trackErrorInteractions);
    // TODO TRACK ERROR
    logNewRelicCustom(NEW_RELIC_EVENTS.PRICE_ADJUSTMENT_API_ERROR, {
      errorMessage: err.toString(),
      cartRequest: designData
    });
    return null;
  }
};
